module.exports = __webpack_public_path__ + "img/plan_t1.f7301514.webp";